import { callAPI } from "./apiUtils";

const safeMessage = (e, fallback = "Request failed") =>
  e?.response?.data?.message || e?.message || fallback;

let accountsInflight = null;

export async function loadTodoistAccounts() {
  if (accountsInflight) return accountsInflight;
  accountsInflight = (async () => {
    try {
      const { data } = await callAPI("/todoist/accounts", {}, "GET");
      if (data?.status === false) return [];
      return data?.data || [];
    } catch (e) {
      console.error("loadTodoistAccounts failed", e);
      return [];
    } finally {
      accountsInflight = null;
    }
  })();
  return accountsInflight;
}

export async function getTodoistOAuthUrl() {
  try {
    const { data } = await callAPI("/todoist/accounts/auth-url", {}, "GET");
    if (data?.status === false) return null;
    return data?.url || null;
  } catch (e) {
    console.error("getTodoistOAuthUrl failed", e);
    return null;
  }
}

export async function syncTodoistAccount() {
  try {
    const { data } = await callAPI("/todoist/accounts/sync", {}, "POST");
    if (data?.status === false) {
      return { ok: false, message: data.message || "Sync failed", data: null };
    }
    return { ok: true, message: data?.message || "Sync finished", data: data?.data || null };
  } catch (e) {
    return { ok: false, message: safeMessage(e, "Sync failed"), data: null };
  }
}

export async function disconnectTodoistAccount(id) {
  try {
    const { data } = await callAPI(`/todoist/accounts/${id}`, {}, "DELETE");
    if (data?.status === false) {
      return { ok: false, message: data.message || "Disconnect failed" };
    }
    return { ok: true, message: data?.message || "Todoist disconnected" };
  } catch (e) {
    return { ok: false, message: safeMessage(e, "Disconnect failed") };
  }
}
